import React from 'react';
import propTypes from 'prop-types';
import { Stack } from '@mui/material';
import { sanitizeDirtyHTML } from 'helpers/strings';

/**
 * renders the carrier feature description notes block of the appointments sidebar
 * @param notes - html notes coming from the carrier's Zoho record
 */
export default function CarrierFeatureNotes({ notes }) {
  if (!notes) return null;

  return (
    <div className='mt-2.5 pt-2.5 border-t border-grey-lightest first:mt-0 first:border-t-0 first:pt-0'>
      <h4 className='text-base font-medium text-black m-0 mb-2'>
        Carrier Feature Description Notes
      </h4>
      <Stack>
        <div
          className='text-left'
          dangerouslySetInnerHTML={sanitizeDirtyHTML(notes)}
        />
      </Stack>
    </div>
  );
}

CarrierFeatureNotes.propTypes = {
  notes: propTypes.string
};
